module.exports = __webpack_public_path__ + "img/carousel-4.6ab4fc1d.png";